import { useState, useEffect } from "react";
import {media} from "../styles/Media"

export const useMediaSize = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(null);

  const onResize = () => {
    const isSmall = window !== undefined && !window.matchMedia(media.large).matches;
    setIsSmallScreen(isSmall);
  };

  useEffect(() => {
    setIsSmallScreen(!window.matchMedia(media.large).matches);
    // Learn more about how { passive: true } improves scrolling performance
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Improving_scrolling_performance_with_passive_listeners
    window.addEventListener("resize", onResize, {passive: true});
    return () => {
      window.removeEventListener("resize", onResize, { passive: true });
    };
  }, []);

  return [isSmallScreen, setIsSmallScreen ];
};
